<template>
    <div id="app">
        <Nav/>
        <div class="contenido">
            <span class="menu-bar  icon-menu text-white d-flex justify-content-center align-items-center"></span>
            <div id="contenidoPagina">
                <router-view/>
            </div>
        </div>
        <Footer/>
    </div>
</template>


<script>

import Nav from '@/components/Nav'
import Footer from '@/components/Footer'

export default {
 name: 'App',
 components:{
   Nav,
   Footer
 }  
}

</script>

